export const SERVER_ENDPOINTS = {
    ACCESSIBILITY_ISSUES: "accessibility-issues",
    BUSINESSES: "businesses",
    CATEGORIES: "categories",
    CONTACT_US: "contact-us",
    ID_REFUSED: "id-refused",
};
